import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

// Pantalla de administración, en una ruta separada ("/admin") y sin enlaces
// hacia ella desde el portal público. Requiere email + contraseña reales.
export function LoginAdmin() {
  const { loginAdmin } = useAuth();
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await loginAdmin(email, pass);
    } catch {
      // Mensaje genérico: no confirmamos si el correo existe.
      setError("Credenciales incorrectas.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="grid min-h-screen place-items-center bg-slate-900 p-4">
      <div className="w-full max-w-sm">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-3 grid h-12 w-12 place-items-center rounded-2xl bg-slate-700 text-xl">
            🔐
          </div>
          <h1 className="text-xl font-bold text-white">Administración</h1>
          <p className="text-sm text-slate-400">Acceso exclusivo del equipo</p>
        </div>

        <div className="rounded-2xl border border-slate-700 bg-slate-800 p-6">
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-400">Correo</label>
              <input
                className="w-full rounded-xl border border-slate-600 bg-slate-900 px-3 py-2 text-sm text-white outline-none focus:border-brand-500"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="username"
              />
            </div>
            <div>
              <label className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-400">Contraseña</label>
              <input
                className="w-full rounded-xl border border-slate-600 bg-slate-900 px-3 py-2 text-sm text-white outline-none focus:border-brand-500"
                type="password"
                value={pass}
                onChange={(e) => setPass(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>

            {error && (
              <p className="rounded-lg bg-rose-500/10 px-3 py-2 text-sm text-rose-400">{error}</p>
            )}

            <button className="btn-primary w-full" disabled={busy}>
              {busy ? "Ingresando…" : "Ingresar"}
            </button>
          </form>
        </div>

        <p className="mt-4 text-center text-xs text-slate-500">
          ¿Eres apoderado? <Link to="/" className="text-brand-400 hover:underline">Ir al portal</Link>
        </p>
      </div>
    </div>
  );
}
